import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const GIRO_PAY_DIRECT: PaymentMethod = {
    id: PAYMENT_METHOD_ID.GiroPayDirect,
    name: 'giropaydirect',
    displayName: 'giropay'
};
